import Vue from 'vue';
import Vuex from 'vuex';

import state from './state';
import fakeState from './mockedState';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

import createLogger from 'vuex/dist/logger';
import UI from './modules/UI';
import InvoiceLifetime from './modules/InvoiceLifetime';

let usedState;

if (process.env.VUE_APP_USE_MOCKS == 'true') {
  /* eslint-disable */
  console.warn('WARNING, YOU ARE USING A FAKE DATA');
  usedState = fakeState;
} else {
  usedState = state;
}
Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const store = {
  state: usedState,
  actions,
  getters,
  mutations,
  plugins: debug ? [createLogger()] : [],
  strict: debug,
  modules: {
    UI,
    InvoiceLifetime,
  },
};

export default new Vuex.Store(store);
